// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__10kLp","wrapper":"styles_wrapper__ejX2p","blockIcon":"styles_blockIcon__2hdKp","arrow":"styles_arrow__3cy-Q"};